module.exports = __webpack_public_path__ + "img/confort.7fc4cb58.jpg";